import React from 'react';
import { 
  ArrowLeft, 
  MoreVertical, 
  Phone, 
  Video, 
  User, 
  Building2,
  CheckCircle,
  Clock,
  X
} from 'lucide-react';
import '../Chat.scss';

const ChatHeader = ({ conversation, onBack, userType, onClose }) => {
  const getStatusBadge = () => {
    if (conversation.status === 'closed') {
      return <span className="chat-header__badge chat-header__badge--closed">Fechado</span>;
    }
    if (conversation.status === 'pending') {
      return <span className="chat-header__badge chat-header__badge--pending">Em espera</span>;
    }
    return <span className="chat-header__badge chat-header__badge--active">Ativo</span>;
  };

  return (
    <div className="chat-header">
      <div className="chat-header__left">
        {onBack && (
          <button className="chat-header__back" onClick={onBack}>
            <ArrowLeft size={20} />
          </button>
        )}

        <div className="chat-header__avatar">
          {conversation.avatar ? (
            <img src={conversation.avatar} alt={conversation.title} />
          ) : (
            <span>{conversation.title?.charAt(0).toUpperCase()}</span>
          )}
        </div>

        <div className="chat-header__info">
          <div className="chat-header__name">
            {conversation.title}
            {getStatusBadge()}
          </div>
          <div className="chat-header__meta">
            {conversation.userType === 'company' ? (
              <Building2 size={14} />
            ) : (
              <User size={14} />
            )}
            <span>
              {conversation.userType === 'company' ? 'Empresa' : 'Freelancer'}
            </span>
            {conversation.jobTitle && (
              <>
                <span className="chat-header__separator">•</span>
                <span className="chat-header__job">{conversation.jobTitle}</span>
              </>
            )}
          </div>
        </div>
      </div>

      <div className="chat-header__right">
        {/* <button className="chat-header__action" aria-label="Chamada">
          <Phone size={18} />
        </button>
        <button className="chat-header__action" aria-label="Vídeo">
          <Video size={18} />
        </button> */}
        {/* {onClose && (
          <button className="chat-header__action chat-header__action--close" onClick={onClose}>
            <X size={18} />
          </button>
        )} */}
      </div>
    </div>
  );
};

export default ChatHeader;